import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const PromptOrganicTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>
                        Aims to reproduce the natural discovery process of a user. <br />
                        Rigorously does not mention the brand name.
                  </p>
            </BaseTooltip>
      );
};
